import { AccountInput } from 'src/graphql'
import { useActions, useCallback, useMutations } from '.'

const useUpdateAccount = () => {
  const actions = useActions()
  const mutations = useMutations()
  return useCallback(
    async (
      account: AccountInput & { profileImageUrl?: string },
      create?: boolean,
    ) => {
      const { profileImageUrl, ...acct } = account

      try {
        const save = create
          ? async () =>
              (await mutations.createAccount({ account: acct })).createAccount
                .account
          : async () =>
              (await mutations.updateAccount({ account: acct })).updateAccount
                .account

        const savedAccount = await save()

        actions.updatedAccount(savedAccount)
      } catch (error) {
        console.error(error)
      }
    },
    [actions, mutations],
  )
}

export default useUpdateAccount
